const pln = new Intl.NumberFormat("pl-PL", { maximumFractionDigits: 0 });
const plnGrosze = new Intl.NumberFormat("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** 685 961 zł; grosze only when there are some (437 189,50 zł), as the answer quotes it. */
export function price(value: number | null, currency = "PLN"): string | null {
  if (value === null || value === undefined) return null;
  if (currency !== "PLN") return new Intl.NumberFormat("pl-PL", { style: "currency", currency }).format(value);
  const n = Number(value);
  return `${(Math.round(n * 100) % 100 !== 0 ? plnGrosze : pln).format(n)} zł`;
}

export function shopPrice(value: number | null, currency = "PLN"): string {
  if (value === null || value === undefined) return "Cena na zapytanie";
  return new Intl.NumberFormat("pl-PL", { style: "currency", currency }).format(value);
}

export function rooms(n: number | null): string | null {
  if (!n) return null;
  if (n === 1) return "1 pokój";
  const last = n % 10;
  const teen = n % 100 >= 12 && n % 100 <= 14;
  return `${n} ${last >= 2 && last <= 4 && !teen ? "pokoje" : "pokoi"}`;
}

export function area(value: number | null): string | null {
  return value ? `${new Intl.NumberFormat("pl-PL", { maximumFractionDigits: 2 }).format(value)} m²` : null;
}

/** "parter", "3. piętro"; as the assistant says it (API developer-prompt.ts). */
export function floor(value: number | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  return value === 0 ? "parter" : value < 0 ? `poziom ${value}` : `${value}. piętro`;
}
